import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  IconButton,
  Modal,
  Fade,
  Autocomplete,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";
import { checkUserLoggedIn, dataURItoFile } from "../shared/commonfunctions";
import { Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import {
  startOverAPICall,
  bankDetailsAPICall,
  stageDetailsAPICall,
  GetPisAccountTypeDropDownAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import {
  IBankDetails,
  IBankPrefillData,
  IRevesePennyDropBankDetails,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import BankStyles from "../pages/Styles/BankDetails.module.scss";
import StageLayout from "../Layouts/StageLayout";
import Dropdown from "../Components/SelectDropdown/DropDown";
import icon from "../Components/assets/Images/iconnew.svg";
import eyeIcon1 from "../Components/assets/Images/eye-slash.svg";
import eyeIcon2 from "../Components/assets/Images/eyeClose.svg";
import upiImage from "../Components/assets/Images/upi-ar21 1.svg";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import manualImage from "../Components/assets/Images/wallet-check-svgrepo-com (1) 1.svg";
import Box from "@mui/material/Box";
import SnackBar from "../Components/SnackBars/SnackBar";
import BackDrop from "../Components/BackDrop";
import BankSnackBar from "../Components/SnackBars/BankSnackBar";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import JsonStyles from "../Components/JsonDataToAadhaarFormat/JsonData.module.scss";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import { useDropzone } from "react-dropzone";
import viewImage from "../Components/assets/Images/view-alt-svgrepo-com 1.svg";
import featherUpload from "../Components/assets/Images/feather_upload-cloud.svg";
import Delete from "@mui/icons-material/Delete";
import csvimage from "../Components/assets/Images/csvimage.svg";
import PdfModal from "../Components/PdfModal/PdfModal";
import ClearIcon from "@mui/icons-material/Clear";
import PreviewModalPopup from "../Components/Modals/PreviewModalPopup";
import ReactCropper from "../Components/ReactCropper/ReactCropper";
import FormatterCheckerBankProof from "./FormatCheckerBankProof";
import { UploadSizes } from "../shared/constants";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/bankicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  p: 1,
  boxShadow: 24,
  borderRadius: "20px",
};

const schema = Yup.object().shape({
  bankAccountNumber: Yup.string()
    .required("Account Number is Required")
    .min(6, "Bank account number should be minimum 6 characters")
    .max(18, "Bank account number should be maximum 18 characters")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .matches(/^(?!.*\s{1,}).*$/, "Spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase()),

  ConfirmBankAccountNumber: Yup.string()
    .required("Confirm Account Number is Required")
    .min(6, "Confirm Bank account number should be minimum 6 characters")
    .max(18, "Confirm Bank account number should be maximum 18 characters")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid Account Number")
    .matches(/^(?!.*\s{1,}).*$/, "Spaces are not allowed")
    .transform((value: any) => value && value.toUpperCase())
    .test(
      "match",
      "Account Number and Confirm Account Number should match",
      function (value) {
        return value === this.parent.bankAccountNumber;
      }
    ),

  ifscNumber: Yup.string()
    .required("IFSC is Required")
    .max(11, "Ifsc number should be maximum 11 characters")
    .min(3, "Minimum 3 letters is required")
    .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid IFSC")
    .transform((value: any) => value && value.toUpperCase()),

  // micrNumber: Yup.string()
  //   .required("MICR is Required")
  //   .max(11)
  //   .matches(/^[a-zA-Z0-9 ]*$/, "Enter Valid MICR")
  //   .transform((value: any) => value && value.toUpperCase()),

  customerNameAsperBank: Yup.string()
    .required("Name is Required")
    .min(3, "Minimum 3 letters is required")
    .max(50)
    // .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    // .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .transform((value: any) => value && value.toUpperCase()),

  nriAccountType: Yup.string().notRequired(),
});

const NRIaccountTypes = ["NRE PIS", "NRO - Non PIS", "NRE Non PIS"];

export default function LinkUsingIFSC() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showAccountNumber, setShowAccountNumber] = React.useState(false);
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [startOverloading, setstartOverloading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [editUpdates, setEditUpdates] = useState<any>(false);
  const [value, setValue] = React.useState(0);

  const [upiID, setUpiId] = useState("");
  const [ifscData, setIFSCData] = useState<any>({
    Bank: "",
    Address: "",
  });

  const [prefillData, setprefillData] = useState<IBankPrefillData>({
    nriAccountType: "",
    bankAccountNumber: "",
    ConfirmBankAccountNumber: "",
    ifscNumber: "",
    customerNameAsperBank: "",
    // micrNumber: "",
  });
  const [rejectMessage, setRejectMessage] = useState("");
  const [editcustomerName, setEditCustomer] = useState(true);
  const [displayManualEnter, setDisplayManualEnter] = useState(true);
  const [upiMode, setUPIMode] = useState(false);
  const [initialOption, setInitialOption] = useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [reversePennyDropStauts, setreversePennyDropStauts] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [getStatus, setGetStatus] = useState(false);
  const [agentPlatform, setAgentPlatform] = useState("");
  const [micrNumber, setMicrNumber] = useState("");
  const [selectedFile, setSelectedFile] = useState<any>(null);

  const [setuDetails, setSetuDetails] = useState({
    id: "",
    shortUrl: "",
    upiLink: "",
  });

  const [bankDetailsFetched, setBankDetailsFetched] = useState<any>({
    accountType: "",
    bankAccountIfsc: "",
    bankAccountName: "",
    bankAccountNumber: "",
    payerVpa: "",
    ifscDetails: { address: "", branch: "", micr: "", name: "" },
  });

  const [fetchedbankDetails, setfetchedbankDetails] = useState({
    bankAddress: "",
    bankName: "",
    branchName: "",
  });
  const [preview, setPreview] = useState<string | null>(null);
  const [showModal, setshowModal] = useState(false);

  const [doneImagePreview, setDoneImagePreview] = useState(false);
  const [showPreviewModal, setshowPreviewModal] = useState(false);
  const [deleteloading, setDeleteLoading] = useState(false);

  const [uploadLoading, setUploadLoading] = useState(false);
  const [image, setImage] = useState<any>();
  const formats: any = ["pdf", "png", "jpeg", "jpg"];
  const maxSize = 10 * 1024 * 1024;
  const [BankProofDocRef, setBankProofDocref] = useState<any>("");
  const [PISLetterDocRef, setPISLetterofDocref] = useState<any>("");
  const [bankUrl, setBankUrl] = useState<any>();
  const [accountTypes, setAccountTypes] = useState([]);
  const [bankProofUploaded, setBankProofUploaded] = useState("");

  const navigationData = routesData;
  const handleClickShowAccountNumber = () =>
    setShowAccountNumber((show) => !show);

  const handleMouseDownAccountNumber = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handlePreview = (data: any) => {};

  const handleBankDocumentID = (data: any) => {
    // console.log("data", data);
    if (data !== "") {
      setBankProofUploaded("Document uploaded successfully");
      setSuccessMessage("Document uploaded successfully");
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    } else {
      setBankProofUploaded("");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let dd_type = "document_type";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        // console.log("document_type", response.data.data);
        setBankProofDocref(
          response.data.data?.bank_proof?.document_type_reference
        );
      })
      .catch((error: any) => {});

    setprefilloading(true);
    let obj: any = {
      stage: "bank",
    };
    // console.log("accountstypes", accountstypes);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        setprefilloading(false);
        const responseData = response.data;

        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        setRejectMessage(response.data.data.ErrorMessage);

        // console.log(
        //   "responseData.data?.bank_proof[1]",
        //   responseData.data?.data.bank_proof[1]
        // );

        if (responseData.data?.data?.bank_proof[1]?.url) {
          setBankUrl(responseData.data?.data?.bank_proof[1].url);
          setBankProofUploaded("Document uploaded successfully");
        }

        setprefillData((prev) => {
          return {
            ...prev,
            nriAccountType: responseData.data.account_type,
          };
        });

        if (responseData.data.data.bank_details[0].account_no) {
          setInitialOption(false);
        }
        if (responseData.data.data.bank_details[0].customer_name) {
          setEditCustomer(false);
        }
        setfetchedbankDetails({
          bankAddress: responseData.data.data.bank_details[0].address,
          bankName: responseData.data.data.bank_details[0].bank_name,
          branchName: responseData.data.data.bank_details[0].branch_name,
        });
        setRejectMessage(response.data.data.ErrorMessage);

        if (response.data.data.data.bank_details?.length > 0) {
          setprefillData((prev) => {
            return {
              ...prev,

              bankAccountNumber:
                responseData.data?.data.bank_details[0].account_no,
              ConfirmBankAccountNumber:
                responseData.data.data.bank_details[0].account_no,
              ifscNumber: responseData.data.data.bank_details[0].ifsc,
              customerNameAsperBank:
                responseData.data.data.bank_details[0].customer_name,
            };
          });
        }

        if (responseData.data.data.bank_details[0].micr) {
          setMicrNumber(responseData.data.data.bank_details[0].micr);
        }

        // setBankDetailsFetched((prev) => {
        //   return {
        //     ...prev,
        //     bankAccountNumber:  responseData.data.bank_details[0].account_no,
        //     ConfirmBankAccountNumber:
        //       responseData.data.bank_details[0].account_no,
        //     bankAccountIfsc: responseData.data.bank_details[0].ifsc,
        //     bankAccountName: responseData.data.bank_details[0].account_no,
        //     accountType: "Savings",
        //     payerVpa: "",
        //     ifscDetails: {
        //       name: responseData.data.bank_details[0].account_no,
        //       address: responseData.data.bank_details.BankAddress,
        //       micr: responseData.data.bank_details.Micr,
        //       branch: responseData.data.bank_details.BranchName,
        //     },
        //   };
        // });
        // if (responseData.data.bank_details.UpiId !== "") {
        //   setValue(1);
        //   setInitialOption(false);
        //   setDisplayManualEnter(false);
        //   setUPIMode(true);
        //   setUpiId(responseData.data.StageDetails.UpiId);
        // }

        setEditUpdates(true);
      })
      .catch((error: any) => {
        // console.log("error", error);
        setprefilloading(false);
      });

    // NewReversePennyDropRequestAPICall({})
    //   .then((response: any) => {
    //     const responseData = response.data;
    //     //console.log("responseData", responseData);
    //     setSetuDetails({
    //       id: responseData.data.id,
    //       shortUrl: responseData.data.shortUrl,
    //       upiLink: responseData.data.upiLink,
    //     });
    //   })
    //   .catch((error: any) => {
    //     //  console.log("error", error);
    //   });

    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      setAgentPlatform("iOS");
    } else if (/android/.test(userAgent)) {
      setAgentPlatform("Android");
    } else {
      setAgentPlatform("Other");
    }
  }, []);

  const handleChangeField = (
    name: string,
    value: any,
    callBack: any,

    values: any
  ) => {
    const ifscCode = value.toUpperCase();
    console.log(ifscCode);
    callBack(name, ifscCode);
    if (ifscCode.length === 11) {
      fetch(`https://ifsc.razorpay.com/${ifscCode}`)
        .then((response) => response.json())
        .then((data) => {
          // callBack("micrNumber", data.MICR === null ? "Not Found" : data.MICR);
          setMicrNumber(data.MICR === null ? "" : data.MICR);
          console.log("data", data);
          if (data === "Not Found") {
            setErrorMessage("Please enter Valid IFSC");
            setIFSCData({
              Bank: "",
              Address: "",
            });
          }
          if (data !== "Not Found") {
            setfetchedbankDetails({
              bankAddress: data.ADDRESS,
              bankName: data.BANK,
              branchName: data.BRANCH,
            });
            setIFSCData({
              Bank: data.BANK,
              Address: data.BRANCH,
            });
          }
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (ifscCode.length < 11) {
      setIFSCData({
        Bank: "",
        Address: "",
      });
    }
  };

  function bankDetails(data: any) {
    // console.log("data", data);

    let obj: any = {
      ifsc: data.ifscNumber.toUpperCase(),
      micr: micrNumber,
      bank_account_number: data.bankAccountNumber,
      customer_name_in_bank: data.customerNameAsperBank.toUpperCase(),
      bank_address: fetchedbankDetails.bankAddress.toUpperCase(),
      bank_name: fetchedbankDetails.bankName.toUpperCase(),
      branch_name: fetchedbankDetails.branchName.toUpperCase(),
      bank_type: "savings",
    };
    setloading(true);
    bankDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);

        setErrorMessage(error.response.data.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 8000);
      });
  }

  const handleDeleteDocument = () => {
    let obj: any = {
      document_purpose: "cmr_proof",
    };
    confirmAlert({
      title: "",
      message: "Are you sure you want to Delete?",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setDeleteLoading(true);
            // deleteDocumentAPICall(obj)
            //   .then((response: any) => {
            //     // console.log("response", response.data);
            //     setDeleteLoading(false);
            //     StageDetails();
            //     setSuccessMessage("Successfully Deleted the File");
            //     setTimeout(() => {
            //       setSuccessMessage("");
            //     }, 5000);
            //     setSelectedFile(null);
            //   })
            //   .catch((error: any) => {
            //     setDeleteLoading(false);
            //     seterrorMessage(
            //       error?.response?.data?.error?.message
            //         ? error?.response?.data?.error?.message
            //         : "Error Deleting the File"
            //     );
            //     setTimeout(() => {
            //       seterrorMessage("");
            //     }, 5000);
            //   });
          },
        },
      ],
    });
  };
  const handleCallBack = (data: any) => {
    if (data === "close") {
      setImage("close");
      setshowModal(false);
      setDoneImagePreview(false);
      setSelectedFile(null);
      setPreview(null);
    } else {
      setImage(data.getCroppedCanvas().toDataURL());
      const ImageData = data;

      if (ImageData !== "undefined") {
        const canvas = ImageData.getCroppedCanvas();
        const dataURL = canvas.toDataURL();
        const file = dataURItoFile(dataURL, "cropped_image.png");
        const formData = new FormData();
        const obj: any = {
          file: file,
          doc_type_ref: "cmr_copy",
          doc_type_purpose: "cmr_proof",
        };
        // formData.append("client_code", userId);
        formData.append("file", obj.file);
        formData.append("doc_type_ref", obj.doc_type_ref);
        formData.append("doc_type_purpose", obj.doc_type_purpose);
        setUploadLoading(true);
        // uploadDocumentsAPICall(formData)
        //   .then((response: any) => {
        //     const responseData = response.data;
        //     setUploadLoading(false);
        //     setFileUploadedStatus(true);
        //     setSuccessMessage("Document Uploaded Successfully");
        //     setTimeout(() => {
        //       setSuccessMessage("");
        //     }, 5000);
        //     setshowModal(false);
        //     setDoneImagePreview(true);
        //   })
        //   .catch((error: any) => {
        //     setUploadLoading(false);
        //     seterrorMessage(
        //       error?.response?.data?.error?.message
        //         ? error.response.data.error.message
        //         : "Error Uploading Document"
        //     );
        //     setTimeout(() => {
        //       seterrorMessage("");
        //     }, 5000);
        //   });
      }
    }
  };
  const handlePdfPreviewDone = () => {
    const formData = new FormData();
    const obj: any = {
      file: selectedFile,
      doc_type_ref: "cmr_copy",
      doc_type_purpose: "cmr_proof",
    };

    formData.append("file", obj.file);
    formData.append("doc_type_ref", obj.doc_type_ref);
    formData.append("doc_type_purpose", obj.doc_type_purpose);
    setUploadLoading(true);
    // uploadDocumentsAPICall(formData)
    //   .then((response: any) => {
    //     const responseData = response.data;
    //     setUploadLoading(false);
    //     setFileUploadedStatus(true);
    //     setSuccessMessage("Document Uploaded Successfully");
    //     setTimeout(() => {
    //       setSuccessMessage("");
    //     }, 5000);
    //     setshowModal(false);
    //     setDoneImagePreview(true);
    //   })
    //   .catch((error: any) => {
    //     setUploadLoading(false);
    //     seterrorMessage(
    //       error?.response?.data?.error?.message
    //         ? error.response.data.error.message
    //         : "Error Uploading Document"
    //     );
    //     setTimeout(() => {
    //       seterrorMessage("");
    //     }, 5000);
    //   });
  };

  const handleClosePreview = () => {
    setshowPreviewModal(false);
  };

  const handleClosePdf = () => {
    setshowModal(false);

    setSelectedFile(null);
  };

  const InitialValues: IBankPrefillData = {
    nriAccountType: prefillData.nriAccountType,
    bankAccountNumber: prefillData.bankAccountNumber,
    ConfirmBankAccountNumber: prefillData.ConfirmBankAccountNumber,
    ifscNumber: prefillData.ifscNumber,
    customerNameAsperBank: prefillData.customerNameAsperBank,
    // accountType: prefillData.accountType,
    // micrNumber: prefillData.micrNumber,
  };

  // console.log("bankProofUploaded", bankProofUploaded);

  return (
    <div className={BankStyles.mainWrapperTop}>
      {/* <StageLayout
        completedStages={completedStages}
        stageName={"Bank Details"}
        navigatePath={"/tradingPreference"}
      /> */}

      <SnackBar message={errorMessage} />
      <SucessSnackBar message={successMessage} />
      <BankSnackBar message={ifscData} />
      <ErrorSnackBar message={rejectMessage} />
      <div className={BankStyles.topSection}>
        <div
          className={BankStyles.back}
          onClick={() => {
            navigate("/passport");
          }}
        >
          <img src={backicon} />{" "}
          <span className={BankStyles.backText}>Back</span>
        </div>
        <div className={BankStyles.step}>
          <img src={keyboardicon} /> Step 5 of 10
        </div>
      </div>

      <div className={BankStyles.wrapper}>
        <div>
          <p className={BankStyles.Header}> NRO Bank Account Details </p>
        </div>

        <p className={BankStyles.subText}>
          We need these details only to verify that this bank account belongs to
          you
        </p>
        {!prefilloading ? (
          <Formik
            validationSchema={schema}
            initialValues={InitialValues}
            onSubmit={(values: any) => {
              // console.log("values", values);
              bankDetails(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,

              setFieldValue,
            }) => {
              // console.log("errors", errors);
              // console.log("values", values);
              return (
                <form
                  noValidate
                  onSubmit={handleSubmit}
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                    // event.code.includes("Enter") && handleSubmit()
                  }}
                  className={BankStyles.form}
                >
                  <div className={BankStyles.container}>
                    <div className={BankStyles.feildSection}>
                      <TextField
                        className={BankStyles.textfeild}
                        id="outlined-basic"
                        label="Account Type"
                        variant="outlined"
                        name="nriAccountType"
                        disabled
                        value={values.nriAccountType}
                        error={
                          touched.nriAccountType &&
                          Boolean(errors.nriAccountType)
                        }
                        helperText={
                          touched.nriAccountType &&
                          errors.nriAccountType?.toString()
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "#111827",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--Black-Black-500, #6B7280)",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "#6B7280",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "#111827",
                              fontWeight: 400,
                              fontSize: "15px",
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={BankStyles.feildSection}>
                      <TextField
                        className={BankStyles.textfeild}
                        id="outlined-basic"
                        label="Full name as per bank account"
                        variant="outlined"
                        name="customerNameAsperBank"
                        disabled={!editcustomerName}
                        value={values.customerNameAsperBank?.toUpperCase()}
                        error={
                          touched.customerNameAsperBank &&
                          Boolean(errors.customerNameAsperBank)
                        }
                        helperText={
                          touched.customerNameAsperBank &&
                          errors.customerNameAsperBank?.toString()
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "#111827",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--Black-Black-500, #6B7280)",
                            fontSize: "14px",
                          },
                          maxLength: 50,
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "#6B7280",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "#111827",
                              fontWeight: 400,
                              fontSize: "15px",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className={BankStyles.container}>
                    <div className={BankStyles.feildSection}>
                      <TextField
                        className={BankStyles.textfeild}
                        id="outlined-basic"
                        label="Branch's IFSC"
                        variant="outlined"
                        name="ifscNumber"
                        value={values.ifscNumber.toUpperCase()}
                        error={touched.ifscNumber && Boolean(errors.ifscNumber)}
                        helperText={
                          touched.ifscNumber && errors.ifscNumber?.toString()
                        }
                        onChange={(event) => {
                          handleChangeField(
                            "ifscNumber",
                            event.target.value,
                            setFieldValue,

                            values
                          );
                        }}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "#111827",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--Black-Black-500, #6B7280)",
                            fontSize: "14px",
                          },
                          maxLength: 11,
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "#6B7280",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "#111827",
                              fontWeight: 400,
                              fontSize: "15px",
                            },
                          },
                        }}
                      />
                    </div>
                    <div className={BankStyles.feildSection}>
                      <TextField
                        className={BankStyles.textfeild}
                        id="outlined-basic"
                        label="Bank Account Number"
                        variant="outlined"
                        name="bankAccountNumber"
                        type="password"
                        value={values.bankAccountNumber.toUpperCase()}
                        error={
                          touched.bankAccountNumber &&
                          Boolean(errors.bankAccountNumber)
                        }
                        helperText={
                          touched.bankAccountNumber &&
                          errors.bankAccountNumber?.toString()
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "#111827",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--Black-Black-500, #6B7280)",
                            fontSize: "14px",
                          },
                          maxLength: 18,
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "#6B7280",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "#111827",
                              fontWeight: 400,
                              fontSize: "15px",
                            },
                          },
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                      />

                      <SnackBar message={message} />
                    </div>
                  </div>

                  <div className={BankStyles.container}>
                    <div className={BankStyles.feildSection}>
                      <TextField
                        className={BankStyles.textfeild}
                        id="outlined-basic"
                        label="Confirm Bank Account Number"
                        variant="outlined"
                        name="ConfirmBankAccountNumber"
                        value={values.ConfirmBankAccountNumber.toUpperCase()}
                        fullWidth
                        error={
                          touched.ConfirmBankAccountNumber &&
                          Boolean(errors.ConfirmBankAccountNumber)
                        }
                        helperText={
                          touched.ConfirmBankAccountNumber &&
                          errors.ConfirmBankAccountNumber?.toString()
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputProps={{
                          sx: {
                            "&::label": {
                              fill: "#111827",
                              fontWeight: 400,
                              fontSize: "14px",
                            },
                            color: "var(--Black-Black-500, #6B7280)",
                            fontSize: "14px",
                          },
                          maxLength: 18,
                        }}
                        sx={{
                          fieldset: {
                            borderColor: "#E5E7EB",
                            borderRadius: "100px",
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            color: "#6B7280",
                            fontWeight: 400,
                            fontSize: "14px",
                            "&.MuiFormLabel-filled": {
                              color: "#111827",
                              fontWeight: 400,
                              fontSize: "15px",
                            },
                          },
                        }}
                        type={showAccountNumber ? "password" : "text"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle account number visibility"
                                onClick={handleClickShowAccountNumber}
                                onMouseDown={handleMouseDownAccountNumber}
                                edge="end"
                              >
                                {showAccountNumber ? (
                                  <img src={eyeIcon1} width={"20px"} />
                                ) : (
                                  <img src={eyeIcon2} width={"20px"} />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className={BankStyles.uploadSignatureSection}>
                      <div>
                        <p className={BankStyles.subText}>
                          {" "}
                          Upload Bank Proof{" "}
                        </p>
                      </div>
                      <div style={{ marginRight: "10px" }}>
                        <FormatterCheckerBankProof
                          acceptedFormats={formats}
                          previewImage={handlePreview}
                          documentRef={BankProofDocRef}
                          documentID={handleBankDocumentID}
                          displayOptions={""}
                          stageDetailsData={bankUrl}
                          name={"Bank Proof"}
                          purpose={BankProofDocRef}
                          pdfSize={UploadSizes["bankproof"].pdfSize}
                          imageSize={UploadSizes["bankproof"].imageSize}
                        />
                      </div>
                    </div>
                  </div>

                  <div className={BankStyles.buttonStack}>
                    <div className={BankStyles.buttonBackandContinueSection}>
                      {values.bankAccountNumber &&
                      values.ConfirmBankAccountNumber &&
                      values.customerNameAsperBank &&
                      values.ifscNumber &&
                      !errors.ConfirmBankAccountNumber &&
                      !errors.ifscNumber &&
                      !errors.bankAccountNumber &&
                      bankProofUploaded === "Document uploaded successfully" ? (
                        // values.micrNumber
                        <LoadingButton
                          loading={loading}
                          variant="contained"
                          type="submit"
                          id="linkUsingIFSCContinueButton"
                          sx={{ height: "50px" }}
                          className={BankStyles.approveButton}
                        >
                          Continue
                        </LoadingButton>
                      ) : (
                        <Button
                          variant="contained"
                          disabled
                          className={BankStyles.approveButton}
                          sx={{ height: "50px" }}
                        >
                          Continue
                        </Button>
                      )}
                    </div>
                    {backdrop && <StartOverBackDrop />}
                    {/* <div className={BankStyles.startOverSection}>
                      <img src={icon} className={BankStyles.iconImage} />
                      <p className={BankStyles.paratext}>
                        {" "}
                        if the above mentioned info not yours
                        <span
                          className={BankStyles.startoverbutton}
                          onClick={handleStartOver}
                        >
                          Start Over
                        </span>
                      </p>
                    </div> */}
                  </div>
                </form>
              );
            }}
          </Formik>
        ) : (
          <div className={BankStyles.backdropStyles}>
            <BackDrop />
          </div>
        )}
      </div>
    </div>
  );
}
